import { useThreadHeaderContext } from '@frontend/thread-header-context';
import { PersonSecondaryInfo, PersonSecondaryInfoProps } from '../person-secondary-info';

type InfoProps = Omit<PersonSecondaryInfoProps, 'personId' | 'groupId' | 'person' | 'groupIds'>;

export const Info = (props: InfoProps) => {
  const { groupId, primaryContact, primaryContactId, contextContact, contextPersonId } = useThreadHeaderContext();
  const hasChildren = Array.isArray(props.children) ? props.children.length > 0 : !!props.children;
  const personId = contextPersonId || contextContact?.personId || primaryContactId || primaryContact?.personId;

  if (!hasChildren && (!personId || !groupId)) return null;

  return (
    <PersonSecondaryInfo
      {...props}
      personId={personId ?? ''}
      groupIds={[groupId]}
      person={contextContact ?? primaryContact}
    />
  );
};
